import React from "react";

function Footer() {
    return (
        <>
        <div className="footer-main">
        <footer className="footer">
                <div className="prod-name">
                    <h3 className="foot-head">products</h3>
                    <p className="ft-content">Mechanical Seal</p>
                    <p className="ft-content">Sealing Materials</p>
                    <p className="ft-content">Water Pump Parts</p>
                    <p className="ft-content">waterpump manufacturing</p>
                    <p className="ft-content">Carbon floating ring seals</p>
                    <p className="ft-content specs">Special products</p>
                </div>
                <div className="foot-cont">
                    <h3 className="foot-head">contact us</h3>
                    <p className="ft-content">email:<a href="#" className="foot-anc">sales@hexatechseal.com</a></p>
                    <p className="ft-content">mobile: 9167862525</p>
                    <p className="ft-content">add: gala no.6/7/8, shanta ind. estate,</p>
                    <p className="ft-content specs">mira road (e), thane-401107.</p>
                </div>
                <div className="follow">
                    <h3 className="foot-head">follow us</h3>
                    <a href="https://www.facebook.com/waterpump.seal/" target="blank"><i class="fa-brands fa-facebook foot-ico"></i></a>
                    <a href="https://www.instagram.com/waterpumpseal/" target="blank"><i class="fa-brands fa-square-instagram foot-ico"></i></a>
                    <a href="#"><i class="fa-brands fa-twitter foot-ico" target="blank"></i></a>
                    <a href="https://www.linkedin.com/in/hexatech-engineering-3ab40a1a0/" target="blank"><i class="fa-brands fa-linkedin foot-ico"></i></a>
                    <h3 className="hexa-top">hexatech seal <br></br>solution LLP.</h3>
                </div>


                {/* <img src="./images/logo.png" className="foot-logo"></img> */}

            </footer>
            <hr className="foot-line"></hr>
            <h5 className="copyright">Copyright © hexatech seal solution LLP, All Rights Reserved.</h5>
        </div>

        <a href="https://wa.me/9167862525?text=Hello%21%20I%E2%80%99d%20like%20to%20inquire%20about%20purchasing%20a%20water%20pump%20seal.%20Could%20you%20please%20provide%20more%20information%3F%20Thank%20you%21"><i class="fa-brands fa-square-whatsapp whats-app"></i></a>
        
        </>
    );
};

export default Footer